import * as React from 'react'

import { connect } from 'react-redux'
import { Application } from 'src/utilities/application/application'
import { IDVStatus } from '../../../utilities/steps'
import IdvFailed from './idv-failed'
import IdvNeedsReview from './idv-needs-review'

type Props = {
  idvStatus?: {
    value?: string
  }
  application?: Application
}

const getCurrentStep = (props): IDVStatus => {
  if (
    props.application.identityVerificationStatus === IDVStatus.NEEDS_REVIEW ||
    props.idvStatus.value === IDVStatus.NEEDS_REVIEW
  ) {
    return IDVStatus.NEEDS_REVIEW
  }

  return IDVStatus.FAILED
}

const IdentityVerificationAwait: React.FC<Props> = props => {
  const step = getCurrentStep(props)
  switch (step) {
    case IDVStatus.NEEDS_REVIEW:
      return <IdvNeedsReview />
    case IDVStatus.FAILED:
    default:
      return <IdvFailed />
  }
}

const mapStateToProps = state => ({
  application: state.application,
  idvStatus: state.idvStatus,
})
export default connect(mapStateToProps, null)(IdentityVerificationAwait)
